import { getCustomerRule } from '../services';
export const fetchRule = (id) => getCustomerRule(id).then(response => formatRule(response?.data));
const formatRule = (response) => {
    const result = {
        name: response?.data?.name || '-',
        createdAt: response?.data?.createdAt || '',
        mainRule: response?.data?.mainRule,
        content: response?.data?.content || '',
        slot: response?.data?.slot || 0,
        enableOverload: response?.data?.enableOverload,
        id: response?.data?.id,
    };
    return result;
};
